// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: corporate-action.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Exchange, exchangeFromJSON, exchangeToJSON } from "./common";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.corporateaction";

export enum Type {
  TYPE_UNKNOWN = 0,
  BONUS = 1,
  SPLIT = 2,
  RIGHTS = 3,
  INTERIM_DIVIDEND = 4,
  FINAL_DIVIDEND = 5,
  SPECIAL_DIVIDEND = 6,
  UNRECOGNIZED = -1,
}

export function typeFromJSON(object: any): Type {
  switch (object) {
    case 0:
    case "TYPE_UNKNOWN":
      return Type.TYPE_UNKNOWN;
    case 1:
    case "BONUS":
      return Type.BONUS;
    case 2:
    case "SPLIT":
      return Type.SPLIT;
    case 3:
    case "RIGHTS":
      return Type.RIGHTS;
    case 4:
    case "INTERIM_DIVIDEND":
      return Type.INTERIM_DIVIDEND;
    case 5:
    case "FINAL_DIVIDEND":
      return Type.FINAL_DIVIDEND;
    case 6:
    case "SPECIAL_DIVIDEND":
      return Type.SPECIAL_DIVIDEND;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Type.UNRECOGNIZED;
  }
}

export function typeToJSON(object: Type): string {
  switch (object) {
    case Type.TYPE_UNKNOWN:
      return "TYPE_UNKNOWN";
    case Type.BONUS:
      return "BONUS";
    case Type.SPLIT:
      return "SPLIT";
    case Type.RIGHTS:
      return "RIGHTS";
    case Type.INTERIM_DIVIDEND:
      return "INTERIM_DIVIDEND";
    case Type.FINAL_DIVIDEND:
      return "FINAL_DIVIDEND";
    case Type.SPECIAL_DIVIDEND:
      return "SPECIAL_DIVIDEND";
    case Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CorporateAction {
  type: Type;
  exDate: number;
  recordDate: number;
  announcementDate: number;
  dividendPercentage: number;
  oldFaceValue: number;
  newFaceValue: number;
  ratioNumerator: number;
  ratioDenominator: number;
  rightsPremium: number;
  dividendAmount: number;
  primaryCode: string;
  companyCode: string;
  primaryExchange: Exchange;
}

function createBaseCorporateAction(): CorporateAction {
  return {
    type: 0,
    exDate: 0,
    recordDate: 0,
    announcementDate: 0,
    dividendPercentage: 0,
    oldFaceValue: 0,
    newFaceValue: 0,
    ratioNumerator: 0,
    ratioDenominator: 0,
    rightsPremium: 0,
    dividendAmount: 0,
    primaryCode: "",
    companyCode: "",
    primaryExchange: 0,
  };
}

export const CorporateAction = {
  encode(message: CorporateAction, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    if (message.exDate !== 0) {
      writer.uint32(32).int64(message.exDate);
    }
    if (message.recordDate !== 0) {
      writer.uint32(40).int64(message.recordDate);
    }
    if (message.announcementDate !== 0) {
      writer.uint32(48).int64(message.announcementDate);
    }
    if (message.dividendPercentage !== 0) {
      writer.uint32(57).double(message.dividendPercentage);
    }
    if (message.oldFaceValue !== 0) {
      writer.uint32(65).double(message.oldFaceValue);
    }
    if (message.newFaceValue !== 0) {
      writer.uint32(81).double(message.newFaceValue);
    }
    if (message.ratioNumerator !== 0) {
      writer.uint32(97).double(message.ratioNumerator);
    }
    if (message.ratioDenominator !== 0) {
      writer.uint32(113).double(message.ratioDenominator);
    }
    if (message.rightsPremium !== 0) {
      writer.uint32(129).double(message.rightsPremium);
    }
    if (message.dividendAmount !== 0) {
      writer.uint32(137).double(message.dividendAmount);
    }
    if (message.primaryCode !== "") {
      writer.uint32(146).string(message.primaryCode);
    }
    if (message.companyCode !== "") {
      writer.uint32(154).string(message.companyCode);
    }
    if (message.primaryExchange !== 0) {
      writer.uint32(160).int32(message.primaryExchange);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CorporateAction {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCorporateAction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3:
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.exDate = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.recordDate = longToNumber(reader.int64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.announcementDate = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 57) {
            break;
          }

          message.dividendPercentage = reader.double();
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.oldFaceValue = reader.double();
          continue;
        case 10:
          if (tag !== 81) {
            break;
          }

          message.newFaceValue = reader.double();
          continue;
        case 12:
          if (tag !== 97) {
            break;
          }

          message.ratioNumerator = reader.double();
          continue;
        case 14:
          if (tag !== 113) {
            break;
          }

          message.ratioDenominator = reader.double();
          continue;
        case 16:
          if (tag !== 129) {
            break;
          }

          message.rightsPremium = reader.double();
          continue;
        case 17:
          if (tag !== 137) {
            break;
          }

          message.dividendAmount = reader.double();
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.primaryCode = reader.string();
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.companyCode = reader.string();
          continue;
        case 20:
          if (tag !== 160) {
            break;
          }

          message.primaryExchange = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CorporateAction {
    return {
      type: isSet(object.type) ? typeFromJSON(object.type) : 0,
      exDate: isSet(object.exDate) ? globalThis.Number(object.exDate) : 0,
      recordDate: isSet(object.recordDate) ? globalThis.Number(object.recordDate) : 0,
      announcementDate: isSet(object.announcementDate) ? globalThis.Number(object.announcementDate) : 0,
      dividendPercentage: isSet(object.dividendPercentage) ? globalThis.Number(object.dividendPercentage) : 0,
      oldFaceValue: isSet(object.oldFaceValue) ? globalThis.Number(object.oldFaceValue) : 0,
      newFaceValue: isSet(object.newFaceValue) ? globalThis.Number(object.newFaceValue) : 0,
      ratioNumerator: isSet(object.ratioNumerator) ? globalThis.Number(object.ratioNumerator) : 0,
      ratioDenominator: isSet(object.ratioDenominator) ? globalThis.Number(object.ratioDenominator) : 0,
      rightsPremium: isSet(object.rightsPremium) ? globalThis.Number(object.rightsPremium) : 0,
      dividendAmount: isSet(object.dividendAmount) ? globalThis.Number(object.dividendAmount) : 0,
      primaryCode: isSet(object.primaryCode) ? globalThis.String(object.primaryCode) : "",
      companyCode: isSet(object.companyCode) ? globalThis.String(object.companyCode) : "",
      primaryExchange: isSet(object.primaryExchange) ? exchangeFromJSON(object.primaryExchange) : 0,
    };
  },

  toJSON(message: CorporateAction): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = typeToJSON(message.type);
    }
    if (message.exDate !== 0) {
      obj.exDate = Math.round(message.exDate);
    }
    if (message.recordDate !== 0) {
      obj.recordDate = Math.round(message.recordDate);
    }
    if (message.announcementDate !== 0) {
      obj.announcementDate = Math.round(message.announcementDate);
    }
    if (message.dividendPercentage !== 0) {
      obj.dividendPercentage = message.dividendPercentage;
    }
    if (message.oldFaceValue !== 0) {
      obj.oldFaceValue = message.oldFaceValue;
    }
    if (message.newFaceValue !== 0) {
      obj.newFaceValue = message.newFaceValue;
    }
    if (message.ratioNumerator !== 0) {
      obj.ratioNumerator = message.ratioNumerator;
    }
    if (message.ratioDenominator !== 0) {
      obj.ratioDenominator = message.ratioDenominator;
    }
    if (message.rightsPremium !== 0) {
      obj.rightsPremium = message.rightsPremium;
    }
    if (message.dividendAmount !== 0) {
      obj.dividendAmount = message.dividendAmount;
    }
    if (message.primaryCode !== "") {
      obj.primaryCode = message.primaryCode;
    }
    if (message.companyCode !== "") {
      obj.companyCode = message.companyCode;
    }
    if (message.primaryExchange !== 0) {
      obj.primaryExchange = exchangeToJSON(message.primaryExchange);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CorporateAction>, I>>(base?: I): CorporateAction {
    return CorporateAction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CorporateAction>, I>>(object: I): CorporateAction {
    const message = createBaseCorporateAction();
    message.type = object.type ?? 0;
    message.exDate = object.exDate ?? 0;
    message.recordDate = object.recordDate ?? 0;
    message.announcementDate = object.announcementDate ?? 0;
    message.dividendPercentage = object.dividendPercentage ?? 0;
    message.oldFaceValue = object.oldFaceValue ?? 0;
    message.newFaceValue = object.newFaceValue ?? 0;
    message.ratioNumerator = object.ratioNumerator ?? 0;
    message.ratioDenominator = object.ratioDenominator ?? 0;
    message.rightsPremium = object.rightsPremium ?? 0;
    message.dividendAmount = object.dividendAmount ?? 0;
    message.primaryCode = object.primaryCode ?? "";
    message.companyCode = object.companyCode ?? "";
    message.primaryExchange = object.primaryExchange ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
